import * as React from 'react';
import { CircularProgress } from '../ProgressBar/CircularProgress';
import { tokens } from '../../theme';

interface Props {
  style?: React.CSSProperties;
  className?: string;
  size?: number;
}
/**
 * @deprecated use Button from @beeline.com/bp-design-system
 */
export const ButtonProgressIcon: React.FC<React.PropsWithChildren<Props>> = ({ style, className, size = 20 }) => (
  <CircularProgress style={{ color: tokens.colorOnPrimary, ...style }} className={className} size={size} />
);
